/* ============================================================
   TRP FEATURED CAROUSEL
   featured-carousel.js

   Shared init for all featured product carousels.
   Called via: window.TRPFeaturedCarousel.init('fcc-xxx')

   Each call is fully scoped to the element with the given ID.
   Multiple instances on one page do not conflict.

   Requires: window.TRPCarouselTouch (loaded via carousel-touch.js)
   ============================================================ */

(function () {
  'use strict';

  if (window.TRPFeaturedCarousel) return;

  function init(sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    var track           = section.querySelector('[data-fcc-track]');
    var progressDesktop = section.querySelector('[data-fcc-progress-desktop] .fcc-progress__fill');
    var progressMobile  = section.querySelector('[data-fcc-progress-mobile] .fcc-progress__fill');
    var prevDesk        = section.querySelector('[data-fcc-prev]');
    var nextDesk        = section.querySelector('[data-fcc-next]');
    var prevMob         = section.querySelector('[data-fcc-mob-prev]');
    var nextMob         = section.querySelector('[data-fcc-mob-next]');
    var allCards        = Array.from(track.querySelectorAll('.fcc-card'));
    var cards           = allCards.slice();

    var perPageConfig = parseInt(section.dataset.fccPerPage, 10) || 4;
    var currentPage   = 0;
    /* iOS scroll-indicator pattern: bar fades in on user interaction,
       fades out 1.5s after last interaction (timer resets on each). */
    var FADE_DELAY_MS = 1500;
    var fadeTimer     = null;

    function perPage() {
      var w = window.innerWidth;
      if (w < 768)  return 2;
      if (w < 1200) return 3;
      return perPageConfig;
    }

    function pageCount() {
      return Math.max(1, Math.ceil(cards.length / perPage()));
    }

    function goTo(page) {
      currentPage = Math.max(0, Math.min(page, pageCount() - 1));
      var cardW  = cards[0] ? cards[0].getBoundingClientRect().width : 0;
      var gap    = parseFloat(getComputedStyle(track).gap) || 12;
      var offset = currentPage * perPage() * (cardW + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateProgress();
      syncArrows();
    }

    var progressFills      = [progressDesktop, progressMobile].filter(Boolean);
    var progressContainers = progressFills.map(function (el) { return el.parentElement; }).filter(Boolean);

    function updateProgress() {
      var total = cards.length;
      var per   = perPage();
      var pct   = total > 0 ? Math.min(100, ((currentPage + 1) * per / total) * 100) : 0;
      progressFills.forEach(function (el) { el.style.width = pct + '%'; });
    }

    function pagesAvailable() {
      return cards.length > 0 ? Math.ceil(cards.length / perPage()) : 0;
    }

    function showProgress() {
      if (pagesAvailable() <= 1) return;
      progressContainers.forEach(function (c) { c.classList.add('is-interacting'); });
      if (fadeTimer) clearTimeout(fadeTimer);
      fadeTimer = setTimeout(hideProgress, FADE_DELAY_MS);
    }

    function hideProgress() {
      if (fadeTimer) { clearTimeout(fadeTimer); fadeTimer = null; }
      progressContainers.forEach(function (c) { c.classList.remove('is-interacting'); });
    }

    function syncArrows() {
      var atStart = currentPage === 0;
      var atEnd   = currentPage >= pageCount() - 1;
      [
        [prevDesk, atStart],
        [nextDesk, atEnd],
        [prevMob,  atStart],
        [nextMob,  atEnd]
      ].forEach(function (pair) {
        if (!pair[0]) return;
        pair[0].classList.toggle('is-hidden', pair[1]);
        pair[0].setAttribute('aria-hidden', String(pair[1]));
        /* Keep tab order in sync with aria-hidden — otherwise keyboard users
           tab into arrows that screen readers are told to ignore. */
        pair[0].tabIndex = pair[1] ? -1 : 0;
      });
    }

    if (prevDesk) prevDesk.addEventListener('click', function () { showProgress(); goTo(currentPage - 1); });
    if (nextDesk) nextDesk.addEventListener('click', function () { showProgress(); goTo(currentPage + 1); });
    if (prevMob)  prevMob.addEventListener('click',  function () { showProgress(); goTo(currentPage - 1); });
    if (nextMob)  nextMob.addEventListener('click',  function () { showProgress(); goTo(currentPage + 1); });

    var filterBtns   = Array.from(section.querySelectorAll('[data-fcc-filter]'));
    var allViewLimit = parseInt(section.dataset.fccAllViewLimit, 10);
    if (isNaN(allViewLimit) || allViewLimit <= 0) allViewLimit = allCards.length;

    function applyFilter(val) {
      currentPage = 0;
      track.style.transform = 'translateX(0)';

      var isAllView = val === '';
      /* Wrap needle + tags in pipes for full-token match (so "rare"
         doesn't match "rare beans" or "unique & rare" partially). */
      var needle = '|' + val.toLowerCase() + '|';

      allCards.forEach(function (card) {
        var show;
        if (isAllView) {
          /* Missing data-fcc-position → show (backward-compat for sections
             that haven't opted into the render-all + cap pattern). */
          var pos = parseInt(card.dataset.fccPosition, 10);
          show = isNaN(pos) || pos < allViewLimit;
        } else {
          var tags = '|' + (card.dataset.fccTags || '').toLowerCase() + '|';
          show = tags.indexOf(needle) !== -1;
        }
        card.style.display = show ? '' : 'none';
      });

      cards = allCards.filter(function (c) { return c.style.display !== 'none'; });
      updateProgress();
      syncArrows();
      if (pagesAvailable() <= 1) hideProgress();
    }

    var titleEl      = section.querySelector('[data-fcc-title]');
    var dynamicTitle = section.dataset.fccDynamicTitle === 'true';
    var defaultTitle = titleEl ? titleEl.textContent : '';

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        if (dynamicTitle && titleEl) {
          var filterVal = btn.dataset.fccFilter || '';
          titleEl.textContent = filterVal === '' ? defaultTitle : btn.textContent.trim();
        }

        applyFilter(btn.dataset.fccFilter || '');
        showProgress();
      });
    });

    if (window.TRPCarouselTouch) {
      window.TRPCarouselTouch.attach(section, {
        onSwipeLeft:  function () { showProgress(); goTo(currentPage + 1); },
        onSwipeRight: function () { showProgress(); goTo(currentPage - 1); }
      });
    }

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { showProgress(); goTo(currentPage - 1); }
      if (e.key === 'ArrowRight') { showProgress(); goTo(currentPage + 1); }
    });

    instances.push({
      id: sectionId,
      onResize: function () {
        updateProgress();
        goTo(currentPage);
      }
    });

    /* Always apply a filter on init so the all-view-limit caps pagination
       (otherwise arrows can navigate past the intended All-view window). */
    if (filterBtns.length > 0) {
      var initialBtn = section.querySelector('[data-fcc-filter].is-active') || filterBtns[0];
      if (!initialBtn.classList.contains('is-active')) initialBtn.classList.add('is-active');
      applyFilter(initialBtn.dataset.fccFilter || '');
    } else {
      applyFilter('');
    }
  }

  /* Shared global resize handler — width-gated so iOS URL-bar height
     changes don't trigger redraws. */
  var instances = [];
  var globalResizeTimer;
  var globalLastWidth = window.innerWidth;

  window.addEventListener('resize', function () {
    if (window.innerWidth === globalLastWidth) return;
    globalLastWidth = window.innerWidth;
    clearTimeout(globalResizeTimer);
    globalResizeTimer = setTimeout(function () {
      instances.forEach(function (instance) {
        instance.onResize();
      });
    }, 200);
  });

  window.TRPFeaturedCarousel = { init: init };
})();
